<div class="dashboard-card-item">
  <div class="dashboard-card-item-title">{{ 'home.activeLicenses.title' | translate }}</div>
  <div class="dashboard-data">
    <div class="dashboard-data-title">{{ 'home.activeLicenses.activeGroups' | translate }}</div>
    <div class="dashboard-data-info">{{ activeGroups }}</div>
  </div>
  <div class="dashboard-data">
    <div class="dashboard-data-title">{{ 'home.activeLicenses.licensesFinished' | translate }}</div>
    <div class="dashboard-data-info">{{ licensesFinished }}</div>
  </div>
</div>
